import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Container } from 'reactstrap';
import { BrowserView, MobileView } from 'react-device-detect';

const Display = ({ goNextQuestion }) => {
  const handleClickGoNextQuestion = () => {
    if (typeof goNextQuestion === 'function') goNextQuestion();
  };

  useEffect(() => {
    document.addEventListener('click', handleClickGoNextQuestion);
    return () => {
      document.removeEventListener('click', handleClickGoNextQuestion);
    };
  });

  return (
    <>
      <BrowserView />
      <MobileView>
        <Container onClick={handleClickGoNextQuestion} />
      </MobileView>
    </>
  );
};

export default Display;

Display.propTypes = {
  goNextQuestion: PropTypes.func,
};

Display.defaultProps = {
  goNextQuestion: undefined,
};
